import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { createPrebuiltHeaderPromoAttributes, createPrebuiltHeaderSubcatPromoAttributes } from '../header-promo-attrs';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { PrebuiltCategoryHeaderData } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'DogHeader',
  props: {
    data: null
  },
  setup(__props: any) {



const title = "Dog Supplies";
const subtitle = "Shop online or in-store for affordable dog supplies. Find dog food, dog treats, dog beds, dog kennels, dog toys and more!";

const image = "url('/assets/images/dxp/prebuilt-headers/Dog-Hero.jpg')";

const gaDataAttributes = createPrebuiltHeaderPromoAttributes(title, subtitle);



return { __sfc: true,title, subtitle, image, gaDataAttributes, UiButton, createPrebuiltHeaderSubcatPromoAttributes, cssVarsToStyleString }
}

})